import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SedsAvatarComponent } from './seds-avatar.component';

@NgModule({
  declarations: [SedsAvatarComponent],
  imports: [CommonModule],
  exports: [SedsAvatarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsAvatarModule {}
